export const AREA_PAGE_FOURTH_MAP_CARD_FLAG = 'area-page-fourth-map-card';
export const RECENTLY_SOLD_NAV_LINK_FLAG = 'nav-recently-sold-link-update';
export const MAP_SINGLE_LISTING_PREVIEW_FLAG = 'map-single-cluster-experiment';
export const NEW_HEADER_FLAG = 'use-new-navigation-menu';
export const MAINTENANCE_BANNER_FLAG = 'scheduled-maintenance-banner';
export const FEEDBACK_BANNER_FLAG = 'feedback-survey-banner';
